import { Button, Col, P } from '@ahmdigital/ui';
import styled from 'styled-components';

import { StyledListbox } from '../../../product/components/cart-price/styles';
import MoreOptionsLink from '../../../../components/navigation-header/components/more-options-link';

export const DisclaimerWrapper = styled.div`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  margin-top: 1.5rem;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    align-items: center;
    flex-direction: row;
    margin-bottom: 2.6rem;
  }
`;

export const HeaderWrapper = styled.div`
  background-image: linear-gradient(
    to right,
    ${({ theme }) => theme.colors.grey20} 65%,
    ${({ theme }) => theme.colors.grey10} 0%
  );
  background-position: bottom;
  background-size: 10px 1px;
  background-repeat: repeat-x;
  padding-bottom: 1.5rem;
  text-align: center;
`;

export const StyledButton = styled(Button)`
  margin-top: 1rem;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin-left: 1rem;
    margin-top: 0;
  }
`;

export const SoftBundleListbox = styled(StyledListbox)`
  position: relative;
  > ul {
    min-width: fit-content;
    left: 50%;
    transform: translateX(-50%);
  }
  button {
    padding: 0 0.5rem;

    &:focus {
      outline-offset: 0;
    }
  }
`;

export const PaymentOptionsWrapper = styled.div`
  align-items: baseline;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    align-items: center;
    display: flex;
  }
`;

export const Label = styled(P)`
  margin-bottom: 0;
  padding-right: 0.25rem;
  display: inline-block;
`;

export const PaymentOption = styled.div`
  margin-right: 1rem;
  margin-bottom: 1.625rem;
  display: inline-block;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin-bottom: 0rem;
  }
`;

export const MovingColumn = styled(Col)`
  transition: left cubic-bezier(0.25, 0.01, 0.25, 1) 0.2s;
  position: relative;
  scroll-snap-align: start;
`;

export const SmallErrorText = styled.small`
  color: ${({ theme }) => theme.colors.redDark};
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  display: block;
  margin-left: 1rem;
  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin-left: 1.4rem;
  }
`;

export const StyledSection = styled.section`
  margin: 0 0 3.5rem 0;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 397px;
  background-color: ${({ theme }) => theme.colors.grey10};
  margin: 0 1rem 1rem 1rem;
  flex-direction: column;
`;

export const StyledMoreOptionsLink = styled(MoreOptionsLink)`
  margin-bottom: 1.5rem;
  display: block;
  text-align: center;
`;
